export default function PHP_MySQLLastID() {
  return (
    <div>
      <h1>PHP_MySQLLastID</h1>
    </div>
  );
}
